<template>
<main>
  <section class="product">
    <h3><span>套餐选择</span><i class="icon-gantanhao-quan"><span>有效期和停留时长以实际出签为准</span></i></h3>
    <ul>
      <li :class="{ on: i === submit.meal }" v-for="(v, i) in _.visa_prices" :key="v.Id" @click="changeMeal(i)">
        <h4>{{v.Name}}</h4>
        <p><span>{{v.TransactCycle}}</span><b>{{v[getPriceAttr]}}</b></p>
      </li>
    </ul>
  </section>
  <section class="day">
    <h3><span>出行日期</span></h3>
    <label for="date">
      <span>{{ submit.day | format }}</span>
      <i></i>
      <input type="date" id="date" :min="deploy.minDay" required v-model="submit.day" @change="checkDay"/>
    </label>
  </section>
  <section class="count">
    <h3><span>购买份数</span></h3>
    <div class="label">
      <i class="icon-jian1" @click="changeCount(-1)"></i>
      <input type="number" step="1" v-model="submit.count" @change="checkCount"/>
      <i class="icon-jia" @click="changeCount(1)"></i>
    </div>
  </section>
  <section class="account" v-show="user.isStaff === 1">
    <h3><span>结算方式</span></h3>
    <ul>
      <li 
        :class="{on: i === deploy.paymentIndex}" 
        v-for="(v, i) in deploy.paymentMethods" :key="v.id"
        @click="deploy.paymentIndex = i">
        <i></i><span>{{v.text}}</span>
      </li>
    </ul>
  </section>
  <footer>
    <p><span>总价：</span><b>{{totalPrice}}</b></p>
    <button class="next" @click="next">下一步</button>
  </footer>
</main>
</template>

<script>
import moment from 'moment';
export default {
  data () {
    return {
      info: {},
      deploy: {
        minDay: null,
        paymentIndex: 0,
        paymentMethods: [
          { id:'CustomerPrice',text:'VIP'},
          { id: 'BigCreditPayment', text: '企业VIP' },
          { id: 'TradePrice', text:'分销现结'},
          { id:'SmallCreditPaymen', text:'分销后结'}
        ],
      },
      submit: {
        day: null,
        count: 1,
        meal: 0
      }
    }
  },
  computed: {
    _ () {
      return this.info;
    },
    user () {
      return this.getUserInfo();
    },
    getPriceAttr () {
      const { isStaff } = this.user;
      if ( isStaff === 1 ) {
        const { paymentIndex, paymentMethods } = this.deploy;
        return paymentMethods[paymentIndex].id;
      }
      return this.getPriceName();
    },
    totalPrice () {
      const { visa_prices } = this.info;
      const { meal, count } = this.submit;
      const visa = visa_prices[meal];
      const attr = this.getPriceAttr;
      return parseFloat((Number(visa[attr]) * count).toFixed(2));
    }
  },
  filters: {
    format (val, desc = 'YYYY年MM月DD日') {
      return val ? moment(val).format(desc) : '请选择';
    }
  },
  created () {
    const info = JSON.parse(sessionStorage.getItem('visaInfo') || 'null');
    if ( !info ) { this.$router.push({ name: 'home' }); return; }
    this.info = info;
    this.resetSubmit();
  },
  methods: {
    next () {
      const { submit } = this;
      sessionStorage.setItem('visaData', JSON.stringify(submit));
      this.$router.push({ name: 'visa_created', query: { priceAttr: this.getPriceAttr } });
    },
    changeCount (val) {
      let value = this.submit.count + val;
      if ( value < 1 ) { value = 1; }
      this.submit = { ...this.submit, count: value };
    },
    checkCount () {
      const { count } = this.submit;
      const val = Number(count);
      if ( !val ) {
        this.submit = { ...this.submit, count: 1 };
      }
    },
    checkDay () {
      const { day } = this.submit;
      const { minDay } = this.deploy;
      const diff = moment(day).diff(minDay, 'd');
      if ( diff < 0 ) {
        this.$toast('最小可选日期为'+minDay);
        this.submit = { ...this.submit, day: minDay };
        return;
      }
    },
    changeMeal (i) {
      this.submit = { ...this.submit, meal: i };
      this.resetSubmit();
    },
    resetSubmit () {
      const { meal } = this.submit;
      const { visa_prices } = this._;
      const visa = visa_prices[meal];
      const day = moment().add(visa.ProcessingDays, 'd').format('YYYY-MM-DD');
      this.submit = { ...this.submit, day };
      this.deploy = { ...this.deploy, minDay: day };
    }
  }
}
</script>

<style scoped src="./push.css"></style>